import { settings } from '@/constants/settings';

const { auth } = settings;

export const isAuthenticated = () => {
  return !!(auth && auth.username && auth.spa_id);
};

export const getSpaId = (): number | undefined => {
  return auth?.spa_id;
};

export const getUsername = (): string | undefined => {
  return auth?.username;
};
